import { AsyncPipe, formatDate } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { TranslationService } from '@spartacus/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { OrderDetailsService } from 'src/app/service/myaccount/order-details.service';
// tslint:disable-next-line: max-line-length

@Component({
  selector: 'app-reorder',
  templateUrl: './reorder.component.html',
  styleUrls: ['./reorder.component.scss'],
  providers: [AsyncPipe],
  standalone: false,
})
export class ReorderComponent implements OnInit {
  @Input() code: string;
  @Input() erpOrderType: string;
  @Input() totalItems: number;
  @Input() orderDetails: any;
  dateFormatted: any;
  activeCartCount: number;
  constructor(
    private orderDetailsService: OrderDetailsService,
    private baseStoreService: BaseStoreService,
    private translation: TranslationService,
    private pipeAsync: AsyncPipe,
    private cartService: ActiveCartService,
    public deviceDetectorService: DeviceDetectorService,
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.baseStoreService
      .getBasestoreData()
      .pipe(take(1))
      .subscribe((baseStoreData) => {
        if (baseStoreData) {
          this.dateFormatted = baseStoreData.dateFormat.replace(/\//g, '');
        }
      });

    this.totalItems = 0;
    this.orderDetailsService
      .getOrderDetails(this.code, this.erpOrderType)
      .pipe(take(1))
      .subscribe((data) => {
        if (data.consignments && data.consignments.length > 0) {
          data.consignments.forEach((consignment: any) => {
            if (consignment.entries.length > 0) {
              consignment.entries.forEach((entry: any) => {
                this.totalItems++;
              });
            }
          });
        }
      });
  }

  onReorderModal(code: string, totalItems: number) {
    this.hasActiveCartCount();
    const cartTotalItems = !totalItems && this.totalItems > 0 ? this.totalItems : totalItems;
    const reorderModalSize = this.activeCartCount > 0 ? 'reorderWithActiveCart' : 'reorder';

    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.RESTORE_SAVED_CART, this.el, this.vcr, {
        cartName: this.pipeAsync.transform(this.getTranslatedValue(`cart.reorderCartName`, code)),
        cartId: code,
        dateFormatted: this.dateFormatted,
        cartTotalItems: cartTotalItems,
        erpOrderType: this.erpOrderType,
        reorder: true,
        reorderDetailsGtmDataLayer: this.setReorderDetailsGtmDataLayerDetails(this.orderDetails),
        windowClass: reorderModalSize,
      })
      ?.pipe(take(1))
      .subscribe();
  }

  hasActiveCartCount() {
    this.cartService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => {
        this.activeCartCount = data.totalItems;
      });
  }

  setReorderDetailsGtmDataLayerDetails(orderDetails: any) {
    const gtmTag = {
      event: 'reorder',
      ecommerce: {
        currency: orderDetails.totalPrice.currencyIso,
        reorder: {
          orderNumber: orderDetails.erpOrderNumber,
          poNumber: orderDetails.purchaseOrderNumber,
          datePlaced: formatDate(new Date(orderDetails.createdDateString), 'dd-MM-yyyy', 'en-US'),
          orderedBy: orderDetails.placedBy,
          totalAmount: orderDetails.totalPrice.value,
          orderType: orderDetails.orderType,
          deliveryAddress: orderDetails.deliveryAddress ? orderDetails.deliveryAddress.formattedAddress : '',
        },
      },
    };
    return gtmTag;
  }

  getTranslatedValue(key: string, param: string): Observable<string> {
    return this.translation.translate(key, { cartId: param });
  }
}
